/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const kindpeople: CommunityData = {
  code: "kindpeople",
  inviteCode: "kindpeople",
  name: "Kind People Club",
  thumbnail: "/assets/customizations/kindpeople/thumbnail.png",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/kindpeople`,
  socials: {},
  styles: {
    global: {
      counterColor: "#000000",
      logo: {
        src: "/assets/customizations/kindpeople/logo.png",
        styles: "w-[128px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      contentBoxShadow: "border-[1px] border-[#1E1E1C]",
      bgColor: "#704FCE",
      asideBg: "#E7DAEE",
      asideStyles: "border-r-[1px] border-r-[#1E1E1C]",
      contentBg: "#E7DAEE",
      bgDesktop: "/assets/customizations/kindpeople/bg.png",
      bgMobile: "/assets/customizations/kindpeople/bg.png",
      mainFont: "font-['RobotoCondensed']",
      primaryButton:
        "flex mt-2 !text-[#FF49C0] font-['Prompt'] uppercase justify-center items-center !text-[16px] leading-[18px] !h-[48px] bg-[#141414] !px-[32px] sm:!min-w-[154px] min-w-[160px] text-nowrap cursor-pointer",
    },
    navigation: {
      sideBarSeparator: "",
      iconsColor: "#000000",
      separator: "border-t-[#1E1E1C] border-t border-opacity-50",
      item: "text-[16px] font-bold h-[40px] text-[#000000] uppercase flex sm:justify-start justify-center items-center sm:!pt-2 !pt-6",
      itemSelected: "custom-prefix",
    },
    communityLanding: {
      titles: "text-[24px] font-bold leading-[28px] uppercase",
      announcements: {
        lg: {
          subtitle:
            "!text-[12px] font-['Prompt'] uppercase px-[6px] !bg-[#E7DAEE] -ml-1 mb-[2px] !text-[#000000] w-fit h-[26px] border-[1px] border-[#434343] flex items-center",
          title:
            "leading-[16px] font-['RobotoCondensed'] font-bold !text-[#FFFFFF] !text-[12px] -mb-2 mt-[-4px] w-fit flex items-cente pt-1",
        },
        sm: {
          subtitle:
            "!text-[12px] font-['Prompt'] uppercase px-[6px] !bg-[#E7DAEE] -ml-1 mb-[2px] !text-[#000000] w-fit h-[26px] border-[1px] border-[#434343] flex items-center",
          title:
            "leading-[16px] font-['RobotoCondensed'] font-bold !text-[#FFFFFF] !text-[12px] mt-[-4px] w-fit flex items-cente pt-1",
        },
      },
      event: {
        title: "font-bold text-[16px] uppercase one-line-truncate",
        subtitle: "text-[14px] font-['Prompt'] leading-[18px]",
      },
      shop: {
        title: "text-[20px] font-bold leading-[24px] uppercase",
        text: "text-[14px] font-['Prompt'] leading-[18px]",
        customShopImage: "/assets/customizations/kindpeople/img_shop.png",
      },
      emptyOrLoadingState: "text-[16px]",
    },
    events: {
      container: "mb-16 sm:p-11 p-7 sm:pb-8 sm:space-y-[57px] space-y-[25px]",
      header: "text-[24px] font-bold leading-[28px] uppercase",
      sectionHeader: "text-[20px] one-line-truncate font-bold uppercase",
      separator: "mb-8 mt-2 border-b border-b-[1px] border-[#1E1E1C]",
      title: "text-[16px] leading-[20px] font-bold uppercase my-2",
      duration: "text-[14px] font-['Propmt']",
      address: "text-[14px] font-['Propmt']",
      emptyOrLoadingState: "text-[16px]",
    },
    event: {
      container: "flex flex-col sm:p-11 p-6",
      blockContainer: "flex flex-col gap-3",
      separator: "sm:my-8 my-6 border-b border-b-[1px] border-[#1E1E1C]",
      header: "text-[24px] font-bold leading-[28px] uppercase !mt-0 sm:mb-0 mb-[24px]",
      sectionSubtitle: "text-[14px] font-['Propmt']",
      sectionTitle: "text-[20px] one-line-truncate font-bold uppercase",
      text: "text-[14px] font-['Propmt']",
      map: {
        border: "mb-2 border-[1px] border-[#1E1E1C] flex justify-center overflow-hidden",
        pin: "",
        pinColor: "#000000",
        strokeColor: "#000000",
      },
      emptyOrLoadingState: "text-[16px]",
    },
    eventTickets: {
      container: "flex flex-col sm:p-11 p-6",
      event: {
        title: "!mt-0 text-[24px] font-bold leading-[28px] uppercase",
        subtitle: "text-[14px] font-['Propmt']",
      },
      separator: "sm:my-8 my-6 border-b-[#1E1E1C] border-b-[1px]",
      ticket: {
        title: "text-[20px] one-line-truncate font-bold uppercase",
        description: "capitalize text-[14px] font-['Propmt']",
        text: "capitalize text-[12px] font-['Propmt']",
        price: "text-[20px] font-bold",
        counterContainer: "text-[12px] border-[1px] !border-[#1E1E1C]",
        quantity: "text-nowrap text-[12px]",
      },
    },
    announcements: {
      container: "mb-16 sm:p-11 p-7 sm:space-y-[38px] space-y-[33px]",
      header: "text-[24px] font-bold leading-[28px] uppercase",
      created: "text-[14px] font-['Prompt'] leading-[18px] uppercase",
      title: "text-[16px] leading-[20px] font-bold uppercase",
      description: "text-[14px] font-['Prompt'] leading-[18px]",
      emptyOrLoadingState: "text-[16px]",
    },
    announcement: {
      container: "sm:p-10 p-7 pb-8 space-y-[23px]",
      created: "text-[14px] font-['Prompt'] leading-[18px] uppercase",
      title: "text-[16px] leading-[20px] font-bold uppercase",
      description: "text-[14px] font-['Prompt'] leading-[18px]",
      likeIconColor: "#000000",
      likeCount: "text-[#000000]",
      commentIconColor: "#000000",
      commentCount: "text-[#000000]",
      emptyOrLoadingState: "text-[16px]",
    },
    shop: {
      container: "mb-16 sm:p-11 p-7 sm:pb-8",
      header: "text-[16px] leading-[20px] font-bold uppercase",
      sectionTitle: "text-[20px] one-line-truncate font-bold uppercase",
      separator: "mt-2 sm:mb-7 mb-6 border-b border-b-[1px] border-[#1E1E1C]",
      emptyState: "text-[16px]",
    },
    linktree: {
      container:
        "font-['Prompt'] flex flex-col items-center h-full w-full bg-cover min-h-screen bg-[#000000] p-[64px]",
      bgDesktop: "/assets/customizations/kindpeople/bg.png",
      bgMobile: "/assets/customizations/kindpeople/bg.png",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full",
        name: "text-[30px] font-['RobotoCondensed'] font-bold",
        location: "font-bold font-['Barlow'] text-[16px] leading-[16px] text-center mb-2",
        description: "text-[14px] leading-[18px] text-center mb-4",
        socialMediaIconColor: "#000000",
        button:
          "flex mt-2 !text-[#FF49C0] font-['Prompt'] uppercase justify-center items-center !text-[16px] leading-[18px] !h-[48px] bg-[#141414] !px-[32px] sm:!min-w-[154px] min-w-[160px] text-nowrap cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[42px] uppercase border-[1px] border-[#414141] !h-[56px] sm:w-[500px] w-[95vw] p-6 flex bg-[#E7DAEE] items-center text-[14px]",
        emptyState: {
          container:
            "border-[#414141] border-[1px] sm:w-[500px] w-[95vw] bg-[#E7DAEE] flex justify-between flex flex-col justify-center items-center p-[34px] mb-[32px]",
          title: "font-bold font-['RobotoCondensed'] uppercase",
          text: "text-[14px]",
          button:
            "flex mt-2 w-fit mt-7 !text-[#FF49C0] font-['Prompt'] uppercase justify-center items-center !text-[16px] leading-[18px] !h-[48px] bg-[#141414] !px-[32px] text-nowrap cursor-pointer",
        },
        header:
          "font-['RobotoCondensed'] font-bold uppercase text-[24px] leading-[28px] mb-[10px] text-center w-screen",
        container: "gap-4 flex flex-col items-center",
        event: {
          container:
            "overflow-hidden border-[#414141] border-[1px] bg-[#E7DAEE] sm:w-[500px] w-[95vw]",
          name: "font-bold font-['RobotoCondensed'] uppercase text-[20px] leading-[24px] mb-1 sm:w-[390px] w-[65vw]",
          duration: "text-[14px] leading-[17px] uppercase",
          location: "text-[14px] leading-[17px]",
          startDate:
            "!w-[64px] h-[64px] font-['RobotoCondensed'] font-bold text-[20px] h-[64px] border-[1px] border-[#1E1E1C] flex flex-col justify-center items-center gap-1",
          button:
            "flex mt-2 w-fit mt-3 !text-[#FF49C0] font-['Prompt'] uppercase justify-center items-center !text-[16px] leading-[18px] !h-[48px] bg-[#141414] !px-[32px] text-nowrap cursor-pointer",
          product: {
            container:
              "h-[74px] border-t border-t-[#1E1E1C] px-4 items-center flex justify-between",
            name: "text-[16px] font-bold font-['RobotoCondensed'] uppercase leading-[19.2px] mb-1 one-line-truncate sm:w-[370px] w-[65vw]",
            price: "text-[14px] leading-[17px]",
            status: "text-[16px] leading-[20px] font-bold font-['RobotoCondensed']",
            link: "text-[14px] leading-[17px]",
            button:
              "flex !text-[#FF49C0] font-['Prompt'] w-[80px] uppercase justify-center items-center !text-[16px] leading-[18px] !h-[48px] bg-[#141414] text-nowrap cursor-pointer",
          },
        },
        collapsedEvent: {
          container:
            "h-[64px] border-[#434343] border-[#1E1E1C] border-[1px] bg-[#E7DAEE] bg-[#141414] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between pr-2",
          media: "overflow-hidden m-2 border-[#1E1E1C] border-[1px] ",
          name: "text-[16px] font-bold uppercase font-['RobotoCondensed'] leading-[16px] pt-[2px] sm:w-[390px] w-[65vw] one-line-truncate",
          duration: "!text-[14px] mt-[-2px] uppercase",
          plusIconColor: "#000000",
        },
        seeAllEvents: "text-[12px] underline text-center mt-4 cursor-pointer mb-[32px]",
      },
      news: {
        container: "flex flex-col gap-4",
        loadingState:
          "mb-[42px] uppercase border-[1px] border-[#414141] !h-[56px] sm:w-[500px] w-[95vw] p-6 flex bg-[#E7DAEE] items-center text-[14px]",
        header:
          "font-['RobotoCondensed'] font-bold uppercase text-[24px] leading-[28px] mb-[10px] text-center w-screen",
        oneNews: {
          container:
            "pr-2 overflow-hidden border-[#1E1E1C] border-[1px] bg-[#E7DAEE] h-[80px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between",
          media: "overflow-hidden border-[#1E1E1C] border-[1px] w-[48px] h-[48px] ml-4 mr-2 mt-4",
          name: "font-['RobotoCondensed'] uppercase font-bold mt-[2px] !text-[16px] leading-[19.2px] mb-1 one-line-truncate sm:w-[390px] w-[65vw]",
          created: "text-[14px] leading-[18px] mt-[-4px] opacity-[80%]",
          triangleIconColor: "#000000",
        },
        seeAllNews: "text-[12px] underline text-center mt-4 cursor-pointer mb-[32px]",
      },
      otherLinks: {
        container: "flex flex-col gap-[10px] mb-[40px]",
        loadingState:
          "mb-[42px] uppercase border-[1px] border-[#414141] !h-[56px] sm:w-[500px] w-[95vw] p-6 flex bg-[#E7DAEE] items-center text-[14px]",
        header:
          "font-['RobotoCondensed'] font-bold uppercase text-[24px] leading-[28px] mb-[10px] text-center w-screen",
        link: {
          container:
            "h-[56px] border-[#1E1E1C] border-[1px] bg-[#E7DAEE] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between",
          name: "ml-1 font-['RobotoCondensed'] font-bold text-[16px] leading-[16px] mb-[6px] mt-[6px] one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#000000",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full object-cover",
        },
      },
      footer: {
        WERZlogoColor: "#000000",
        text: "uppercase font-mono text-[11px] font-bold text-[#000000]",
      },
    },
  },
}

export default kindpeople
